'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _xstate = require('xstate');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withStatechart = function withStatechart(statechart) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var StateMachine = function (_React$Component) {
      _inherits(StateMachine, _React$Component);

      function StateMachine(props) {
        _classCallCheck(this, StateMachine);

        var _this = _possibleConstructorReturn(this, (StateMachine.__proto__ || Object.getPrototypeOf(StateMachine)).call(this, props));

        _this.machine = (0, _xstate.Machine)(statechart);

        _this.handleRef = function (element) {
          _this.instance = element;
        };

        _this.handleTransition = function (event, updater) {
          var _ref2;

          if ((_ref2 = _this) != null ? (_ref2 = _ref2.instance) != null ? _ref2.componentWillTransition : _ref2 : _ref2) {
            _this.instance.componentWillTransition(event);
          }

          _this.setState(function (prevState) {
            var stateChange = typeof updater === 'function' ? updater(prevState.componentState) : updater;
            var nextState = _this.machine.transition(prevState.machineState.value, event, stateChange);

            return {
              componentState: _extends({}, prevState.componentState, stateChange),
              event: event,
              machineState: nextState
            };
          });
        };

        var initialMachineState = _this.props.initialMachineState ? _xstate.State.from(_this.props.initialMachineState) : _this.machine.initialState;

        _this.state = {
          componentState: _this.props.initialData,
          machineState: initialMachineState
        };

        _this.handleRef = !(0, _utils.isStateless)(Component) ? _this.handleRef : null;
        return _this;
      }

      _createClass(StateMachine, [{
        key: 'getChildContext',
        value: function getChildContext() {
          var channel = options.channel || 'DEFAULT';

          return {
            automata: _extends({}, this.context.automata, _defineProperty({}, channel, {
              actions: this.state.machineState.actions,
              machineState: this.state.machineState.toString() || (0, _utils.stringify)(this.state.machineState.value)
            }))
          };
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          if (options.devTools && window.__REDUX_DEVTOOLS_EXTENSION__) {
            this.devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect({
              name: (0, _utils.getComponentName)(Component)
            });
            this.devTools.init(this.state);

            this.unsubscribe = this.devTools.subscribe(function (message) {
              if (message.type === 'DISPATCH' && message.payload.type === 'JUMP_TO_ACTION') {
                _this2.jumpToAction = true;
                _this2.setState(JSON.parse(message.state));
              }
            });
          }

          this.runActionMethods();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.unsubscribe) {
            this.unsubscribe();
          }

          if (window.__REDUX_DEVTOOLS_EXTENSION__) {
            window.__REDUX_DEVTOOLS_EXTENSION__.disconnect();
          }
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
          if (!this.jumpToAction) {
            this.handleComponentDidUpdate(prevProps, prevState);
          } else {
            this.jumpToAction = false;
          }
        }
      }, {
        key: 'runActionMethods',
        value: function runActionMethods() {
          var _this3 = this;

          if (this.instance) {
            this.state.machineState.actions.forEach(function (action) {
              if (_this3.instance[action]) {
                _this3.instance[action]();
              }
            });
          }
        }
      }, {
        key: 'handleComponentDidUpdate',
        value: function handleComponentDidUpdate(prevProps, prevState) {
          if (prevState.machineState.actions !== this.state.machineState.actions) {
            this.runActionMethods();
          }

          if (prevState.machineState !== this.state.machineState) {
            var _ref;

            if ((_ref = this) != null ? (_ref = _ref.instance) != null ? _ref.componentDidTransition : _ref : _ref) {
              this.instance.componentDidTransition(prevState.machineState.value, this.state.event);
            }

            if (this.devTools) {
              this.devTools.send(this.state.event, this.state);
            }
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(Component, _extends({}, this.props, this.state.componentState, {
            machineState: this.state.machineState.value,
            ref: this.handleRef,
            transition: this.handleTransition
          }));
        }
      }]);

      return StateMachine;
    }(_react2.default.Component);

    StateMachine.propTypes = {
      initialData: _propTypes2.default.object,
      initialMachineState: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])
    };

    StateMachine.contextTypes = {
      automata: _propTypes2.default.object
    };

    StateMachine.childContextTypes = {
      automata: _propTypes2.default.object
    };

    return StateMachine;
  };
};

exports.default = withStatechart;


//////////////////
// WEBPACK FOOTER
// ./~/react-automata/lib/withStatechart.js
// module id = 480
// module chunks = 168707334958949